import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

export default function InfoCardSection({ title, titleColor, lineColor, items }) {
  return (
    <Box
      sx={{
        maxWidth: '450px',
        backgroundColor: 'white',
        textAlign: 'center',
        px: 4,
        pt: 8,
        pb: 2,
        borderRadius: '100px 100px 15px 15px',
        filter: 'drop-shadow(5px 5px 0.4rem rgb(0,0,0,0.2))'
        
      }}
    >
      <Typography
        sx={{
          color: titleColor || '#000',
          fontSize: {xs:'22px',sm:'28px'},
          fontWeight: '900',
          letterSpacing: {xs:1,sm:2},
          lineHeight: 0
        }}
      >
        {title}
      </Typography>

      <Box my={3} width="100%" height="2px" bgcolor={lineColor || '#000'} />

      <Grid container sx={{ gap: 2 }}>
        {items.map((item, index) => (
          <Grid item key={index} sx={{ display: 'flex', alignItems:'center', maxWidth: '370px', gap: 2, minHeight:'53px' }}>
            <Box>
              <img
                src={item.icon}
                alt={item.alt}
                style={{ height: 'auto', maxWidth: '36px' }}
              />
            </Box>
            <Typography sx={{ fontSize: '12px', textAlign: 'justify', lineHeight:1.5 }}>
              {item.text}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
